import script from "./AboutView.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutView.vue?vue&type=script&setup=true&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=9eccc798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eccc798"]])

export default __exports__